/* Sekme 4 — akşam yemeği & müzik. Günün en atmosferik ekranı. */

import type { Lang, SiteContent } from "../../shared/types.js";
import { t } from "../../shared/types.js";
import { ui } from "../lib/i18n.js";

export function EveningTab({ content, lang }: { content: SiteContent; lang: Lang }) {
  const { evening } = content;

  return (
    <div style={{ paddingTop: 28 }}>
      <h2 className="eyebrow">{ui("navEvening", lang)}</h2>
      <h1 className="display">{ui("eveningTitle", lang)}</h1>
      <p className="lede">{t(evening.intro, lang)}</p>

      <div
        aria-hidden="true"
        className="rise"
        style={{
          marginTop: 26,
          height: 3,
          borderRadius: 3,
          background:
            "linear-gradient(90deg, rgba(201,164,107,.7), rgba(95,191,160,.45) 55%, transparent)",
        }}
      />

      <div className="stack" style={{ gap: 0, marginTop: 8 }}>
        {evening.blocks.map((b, i) => (
          <section
            key={b.id}
            className="rise"
            style={{
              ["--i" as string]: Math.min(i, 8),
              padding: "22px 0",
              borderBottom:
                i === evening.blocks.length - 1 ? "none" : "1px solid var(--line-soft)",
            }}
          >
            <div className="tnum" style={{ color: "var(--gold)", fontSize: 15, letterSpacing: "0.04em" }}>
              {b.time}
            </div>
            <h3 className="serif" style={{ fontSize: 26, lineHeight: 1.16, margin: "8px 0 0" }}>
              {t(b.title, lang)}
            </h3>
            {t(b.text, lang) && (
              <p
                className="muted"
                style={{
                  margin: "8px 0 0",
                  fontSize: 15.5,
                  textWrap: "pretty",
                  whiteSpace: "pre-line",
                }}
              >
                {t(b.text, lang)}
              </p>
            )}
          </section>
        ))}
      </div>
    </div>
  );
}
